<script lang="ts">
    export let height = "h-6";
    export let width = "w-6";
    export let strokeColor = "stroke-mdark";
    export let fillColor = "fill-mdark";
    export let hover = "group-hover:fill-mblue group-hover:stroke-mblue";
    export let strokeWidth = "0.1";
    export let classList = "aspect-ratio transition-all";
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon {height} {width} {strokeColor} {fillColor} {classList} {hover}"
    stroke-width={strokeWidth}
    stroke-linecap="round"
    stroke-linejoin="round"
    viewBox="0 0 24 24"
>
    <path d="M21 9.75C20.59 9.75 20.25 9.41 20.25 9V3.75H15C14.59 3.75 14.25 3.41 14.25 3C14.25 2.59 14.59 2.25 15 2.25H21C21.41 2.25 21.75 2.59 21.75 3V9C21.75 9.41 21.41 9.75 21 9.75Z"/>
    <path d="M9 21.75H3C2.59 21.75 2.25 21.41 2.25 21V15C2.25 14.59 2.59 14.25 3 14.25C3.41 14.25 3.75 14.59 3.75 15V20.25H9C9.41 20.25 9.75 20.59 9.75 21C9.75 21.41 9.41 21.75 9 21.75Z"/>
    <path d="M13.4999 11.25C13.3099 11.25 13.1199 11.18 12.9699 11.03C12.6799 10.74 12.6799 10.26 12.9699 9.97L20.4699 2.47C20.7599 2.18 21.2399 2.18 21.5299 2.47C21.8199 2.76 21.8199 3.24 21.5299 3.53L14.0299 11.03C13.8799 11.18 13.6899 11.25 13.4999 11.25Z"/>
    <path d="M2.99994 21.75C2.80994 21.75 2.61994 21.68 2.46994 21.53C2.17994 21.24 2.17994 20.76 2.46994 20.47L9.96994 12.97C10.2599 12.68 10.7399 12.68 11.0299 12.97C11.3199 13.26 11.3199 13.74 11.0299 14.03L3.52994 21.53C3.37994 21.68 3.18994 21.75 2.99994 21.75Z"/>
</svg>
